var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_944_1317)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 16,
    fill: "#3087EC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_944_1317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 26L32.04 20.44C32.18 20.3 32.18 20.08 32.04 19.94C31.9 19.8 31.68 19.8 31.54 19.94L26 25.5L20.44 19.96C20.3 19.82 20.08 19.82 19.94 19.96C19.8 20.1 19.8 20.32 19.94 20.46L25.5 26L19.96 31.56C19.82 31.7 19.82 31.92 19.96 32.06C20.02 32.12 20.12 32.16 20.2 32.16C20.28 32.16 20.38 32.12 20.44 32.06L26 26.5L31.54 32.06C31.6 32.12 31.7 32.16 31.78 32.16C31.86 32.16 31.96 32.12 32.02 32.06C32.16 31.92 32.16 31.7 32.02 31.56L26.5 26Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_944_1317",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_944_1317"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_944_1317",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_944_1317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.8,
    height: 12.8,
    fill: "white",
    transform: "translate(19.6 19.6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.750ec9d33ec9c2a9f3db5cd94dc503c2.svg";
export { ForwardRef as ReactComponent };